"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PROTOCOLS", {
  enumerable: true,
  get: function get() {
    return _socketConfig.PROTOCOLS;
  }
});
Object.defineProperty(exports, "PROTOCOLS_WS", {
  enumerable: true,
  get: function get() {
    return _socketConfig.PROTOCOLS_WS;
  }
});
Object.defineProperty(exports, "readyStateText", {
  enumerable: true,
  get: function get() {
    return _socketConfig.readyStateText;
  }
});
Object.defineProperty(exports, "readyStates", {
  enumerable: true,
  get: function get() {
    return _socketConfig.readyStates;
  }
});
Object.defineProperty(exports, "socketEmitter", {
  enumerable: true,
  get: function get() {
    return _WebSocketAction.socketEmitter;
  }
});
Object.defineProperty(exports, "socketMessage", {
  enumerable: true,
  get: function get() {
    return _WebSocketAction.socketMessage;
  }
});
Object.defineProperty(exports, "socketSend", {
  enumerable: true,
  get: function get() {
    return _WebSocketAction.socketSend;
  }
});
Object.defineProperty(exports, "useConnectInit", {
  enumerable: true,
  get: function get() {
    return _useConnectInit.useConnectInit;
  }
});
Object.defineProperty(exports, "useConnectSocket", {
  enumerable: true,
  get: function get() {
    return _useWebSocket.useConnectSocket;
  }
});
var _socketConfig = require("./lib/socket-config");
var _WebSocketAction = require("./lib/WebSocketAction");
var _useWebSocket = require("./lib/useWebSocket");
var _useConnectInit = require("./lib/useConnectInit");